import scrollToElement from 'scroll-to-element';

export default class ScrollToSummitGallery {

	constructor() {
		const params = new URLSearchParams(window.location.search);
		this.gallerySection = document.getElementById('summit-gallery');
		this.adminBar = document.getElementById('wpadminbar');
		this.masthead = document.getElementById('masthead');
		this.galleryType = params.get('gallery-type');
	}

	init() {
		this.scroll();
	}

	destroy() {

	}

	getOffset() {
		const adminBarHeight = (this.adminBar instanceof HTMLElement) ? this.adminBar.clientHeight : 0;
		const mastheadHeight = (this.masthead instanceof HTMLElement) ? this.masthead.clientHeight : 0;
		return ((adminBarHeight + mastheadHeight) * -1);
	}

	scroll() {
		if ((this.gallerySection instanceof HTMLElement) && this.galleryType) {
			scrollToElement(this.gallerySection, {
				offset: this.getOffset(),
				ease: 'in-out-quad',
				duration: 100,
			});
		}
	}
}
